import { render } from "./direccionesComponent.vue?vue&type=template&id=446e70b4"
import script from "./direccionesComponent.vue?vue&type=script&lang=js"
export * from "./direccionesComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__